import React, { HTMLAttributes } from 'react';
import { TLazyIconKey } from '../../../../utilities/iconLoader/FontAwesomeIcon';
import { TopBarTypes } from '../TopBar/topBarTypes';
import { HeaderTypes } from '../Header';

export namespace NavBarTypes {
  export type TLocationVariant = 'single' | 'multi';

  export type TFacilityDetails = {
    facilityName: string;
    facilityAddress: string;
    googleMapsUrl: string;
    facilityLogo: TLogo;
  };
  export type TNavBarLogo = {
    facility: TFacilityDetails;
    handleNavBarStateForLogo: (e: React.ChangeEvent<HTMLInputElement>) => void;
  };
  export type TNavLinksMap = {
    NavLinkText: string;
    isNavLinkDropDown: boolean;
    isGrouped?: boolean;
    navLinkDropDown: TNavLinkDropDown[];
    linkTo: string;
    RenderAs: ({ children }: any) => JSX.Element;
  };
  export type TIconsConfig = {
    facilityAddressIcon: TLazyIconKey;
    phoneNumberIcon: TLazyIconKey;
  };
  export type TNavBarIconAndBurgerHelper = {
    facility: TFacilityDetails;
    iconsConfig: TIconsConfig;
    phoneNumber?: string;
    phoneNumberRedirect: string;
    locationType: TLocationVariant;
    handlenavbarBurgerState: () => void;
    handleNavBarStateForLogo: (e: React.ChangeEvent<HTMLInputElement>) => void;
    openNavBar: boolean;
  };
  export type TCTAIconType = {
    name: TLazyIconKey;
    position?: 'left' | 'right';
    type: string;
    size: 16 | number;
  };
  export type TButtonsConfig = {
    label: 'Pay Rent ' | 'Reserve ' | string;
    url: string;
    icon: TCTAIconType;
  };
  export type variantAndFunctions = {
    handleNavBarFunctions: THandleNavBarFunctions;
  };
  export type TThemeModes = 'light' | 'dark';
  export interface INavBarConfig extends HTMLAttributes<HTMLDivElement> {
    theme?: TThemeModes;
    locations: TLocations;
    iconsConfig: TIconsConfig;
    locationType: TLocationVariant;
    navLinks: TNavLink[];
    LinkWrapper: React.ElementType;
    buttonsConfig: TButtonsConfig[];
    GatsbyImage?: React.ComponentType;
    onSetNavBarHeight?: React.Dispatch<React.SetStateAction<number>>;
    locationDetails?: any;
    globalContext?: any;
    logOutHandler?: () => any;
  }

  export type TNavLinkDropDown = {
    subLinkName: string;
    subLinkUrl: string;
    location_state: string;
    location_city: string;
  };

  export type TNavLink = {
    NavLinkText: string;
    isNavLinkDropDown: boolean;
    isGrouped?: boolean;
    linkTo: string;
    onClick?: (event: React.MouseEvent<HTMLElement>) => void;
    RenderAs: React.ElementType;
    newTab: boolean;
    payrentTab?: boolean;
    locationType?: TLocationVariant;
    navLinkDropDown: TNavLinkDropDown[];
  };

  export type TNavbarVariantModes =
    | 'header-1'
    | 'header-2'
    | 'header-3'
    | string;

  export type TLocations = {
    location: TLocation;
  };
  export type TLocation = {
    id: string;
    socialIcons: TIconsType[];
    facilityDetails: TFacilityDetails;
    phoneNumber: string;
  };

  export type TLogo = {
    logo: string;
    renderAs: React.ElementType;
    altText: string;
    height: string | number;
    width: string | number;
  };
  export type THandleNavBarFunctions = {
    handleNavBarBurgerState: () => void;
    handleReRouting: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleDropDownState: (e: any) => void;
    handleNavBarState: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleNavBarStateButton: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleNavBarStateForLogo: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleNavBarRef: (text: string) => void;
  };

  export type TVariantDataType = {
    locationType: TLocationVariant;
    iconsConfig: TIconsConfig;
    facilityDetails: TFacilityDetails;
    phoneNumber?: string;
    phoneNumberRedirect: string;
    handleNavBarFunctions: THandleNavBarFunctions;
    openNavBar: boolean;
    LinkWrapper: React.ElementType;
    navLinks: TNavLink[];
    socialIconsandUrls: TSocialIconsandUrls;
    renderPhoneNumberIcon: () => any;
    buttonsConfig: TButtonsConfig[];
    globalContext?: any;
    logOutHandler?: () => any;
  };
  export type TSocialIconsandUrls = {
    socialIcons: TopBarTypes.TIconsType[];
  };
  export type TSocialIconsAndState = {
    socialIconsandUrls: TSocialIconsandUrls;
    handlenavbarBurgerState: () => void;
    openNavBar: boolean;
    locationType?: TLocationVariant;
  };
  export type TIconsType = {
    iconName: TLazyIconKey;
    iconsUrl: string;
  };
  export type TButtonGroupType = {
    buttonsConfig: TButtonsConfig[];
    handleNavBarStateButton: (e: React.ChangeEvent<HTMLInputElement>) => void;
  };
  export type TGenericButtonGroupType = {
    buttonConfig: TButtonsConfig;
    handleNavBarStateButton: (e: React.ChangeEvent<HTMLInputElement>) => void;
    currentVariant?: any;
    width: number;
    index: number;
  };

  export type TReserveUnitButtonGroupType = {
    buttonsConfig: TButtonsConfig[];
    handleNavBarStateButton: (e: React.ChangeEvent<HTMLInputElement>) => void;
    width: number;
  };
  export type TNavBarIcons = {
    AddressIcon: TLazyIconKey;
    facilityAddress: string;
    googleMapsUrl: string;
    PhoneNumberIcon: TLazyIconKey;
    phoneNumber?: string;
    phoneNumberRedirect: string;
    locationType: TLocationVariant;
    iconsConfig: TIconsConfig;
  };
  export type TNavBarMenu = {
    navLinks: TNavLink[];
    openNavBar: boolean;
    locationType?: TLocationVariant;
    LinkWrapper: React.ElementType;
    globalContext?: any;
  };
  export type TNavBarMenuHelper = TNavBarMenu & {
    socialMediaIconsAndState: TSocialIconsAndState;
    iconsConfig: TIconsConfig;
    renderPhoneNumberIcon: () => any;
    buttonsConfig: TButtonsConfig[];
    handleNavBarFunctions: THandleNavBarFunctions;
    LinkWrapper: React.ElementType;
    globalContext?: any;
    logOutHandler?: () => any;
  };
  export type TGenericButtonLinks = {
    handleNavBarStateButton: (e: React.ChangeEvent<HTMLInputElement>) => void;
    width: number;
    button: TButtonsConfig;
    index: number;
  };
  export type THeaderLinkContent = {
    locationDetails: any;
    NavLinkText: string;
    linkTo: string;
    navLinkDropDown: TNavLinkDropDown[];
    isGrouped?: boolean;
    isNavLinkDropDown: boolean;
    openNavBar: boolean;
    LinkWrapper: React.ElementType;
    className?: string;
    newTab?: boolean;
    globalContext?: any;
    selectedLocationName: string;
  };
  export type TCPHeaderLinkWrapper = {
    children: JSX.Element | JSX.Element[] | any;
    NavLinkText: string;
    className?: string;
    index: number;
  };
  export type TTickMarkTypes = {
    currentDetails: any;
    NavLinkText: string;
  };
  export type TLinkTouchTypes = {
    locationDetails: any;
    linkTo: string;
    NavLinkText: string;
    navLinkDropDown: TNavLinkDropDown[];
  };
  export type TTenantAvatarTypes = {
    globalContext: any;
    logOutHandler?: any;
    accountSelectionUrl?: any;
    currentLocation: HeaderTypes.TLocationDetails;
    siteType: string;
  };
  export type TSignInAvatarComponentTypes = {
    globalContext: any;
    logOutHandler?: any;
    buttonsConfig?: any;
    handleNavBarFunctions?: any;
  };
  export type TSignInAvatarHelpersTypes = {
    onClickHandler?: any;
    iconName?: any;
    label?: string;
  };
}
